import { useQuery } from 'react-query'

import { useAuthentication } from '@hooks/useAuthentication'
import { useMyReadingAction } from './useMyReadingAction'

export const useGetBookShelfStatus = (bookId: number) => {
  const myReadingClient = useMyReadingAction()
  const { isAuthenticated } = useAuthentication()
  const { data, isLoading, refetch } = useQuery(
    ['status-shelf', bookId],
    () => myReadingClient.getStatusShelf(bookId),
    { enabled: !!bookId && isAuthenticated }
  )

  return { data, isLoading, refetch }
}
